'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _message = require('./message.html');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _message2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    content: '<',
    title: '@'
  },
  controller: function MessageComponent() {
    'ngInject';

    _classCallCheck(this, MessageComponent);
  }
};


// WEBPACK FOOTER //
// ./components/app/dashboard/message/message.component.js